import { any, length, test, trim, pipe, juxt, reject, join } from "ramda";
import { isBlank } from "./presence.js";

export const combineValidations = validations => pipe(
  juxt(validations),
  reject(isBlank),
  join("\n"),
);

const trimString = value => typeof value === "string" ? trim(value) : value;
const strictIsBlank = pipe(trimString, isBlank);

export const lengthOf = ({ minimum, maximum }) => value => {
  if(minimum && !maximum) {
    if(length(value) < minimum) {
      return `This field must be ${minimum} characters long.`
    }
  }

  if(maximum && !minimum) {
    if(length(value) > maximum) {
      return `This field must be less than ${maximum} characters long.`
    }
  }

  if(length(value) < minimum || length(value) > maximum) {
    return `This field must be be between ${minimum} and ${maximum} characters long.`
  }

  return null;
}

export const presence = value => {
  if(Array.isArray(value)) {
    return any(strictIsBlank, value) ? "This field is required." : null;
  }

  return strictIsBlank(value) ? "This field is required." : null
}

export const presenceIf = predicate => (value, context) =>
  predicate(context) && strictIsBlank(value) ? "This field is required." : null

export const exclusionFrom = (list, message = "This is not a valid option.") => value =>
  !list.map(v => v.toLowerCase()).includes(value?.toLowerCase()) ? null : message;

export const formatOf = ({ pattern, message }) => value => {
  return test(pattern, value) ? null : (message || "This field doesn't match the correct format.");
};

export const exclusionFromIf = (list, message, predicate) => (value, context) => {
  if (!predicate(context))  {
    return null;
  }

  return exclusionFrom(list, message)(value);
};

export const formatOfIf = ({ pattern, message, predicate }) => (value, context) => {
  if (!predicate(context))  {
    return null;
  }

  return formatOf({ pattern, message })(value);
};
